import Accordion from './accordion.js';
import Tabs from './tabs.js';
import TabAccordion from './tabAccordion.js';
import { breakpointMatch } from '../../../core';

const mobileAccordion = new Accordion('[data-tab-accordion-event-listener]', '[data-tab-accordion-content]', 'specs-home-main-content__item--active');
const contentAccordion = new Accordion('[data-accordion-event-listener]', '[data-accordion-content]', 'content-accordion__item--active');
const tabContent = new Tabs('[data-tab]', '[data-tab-accordion-content]', 'specs-home__tab--active', 'specs-home-main-content__item--active');
const tabAccordion = new TabAccordion(mobileAccordion.accordionEventListener, tabContent.tabEventListener, tabContent.activeTabClass);

initSpecsHomepage();

function initSpecsHomepage(){
  // For mobile
  if (window.matchMedia('(max-width: 766px)').matches){
    mobileAccordion.enableClick();
    contentAccordion.disableClick();
    tabAccordion.enableClick();
  } else { // For desktop
    tabContent.showTabContent(0);
    tabAccordion.disableClick();
    mobileAccordion.disableClick();
    contentAccordion.enableClick();
  }

  // Initialize all events!
  mobileAccordion.initEventListeners();
  contentAccordion.initEventListeners();
  tabContent.initEventListeners();
  tabAccordion.initEventListeners();
}

// Mobile/desktop breakpoint event
breakpointMatch['break-1'].addListener((e) => {
  if (!e.matches) {
    mobileAccordion.enableClick();
    tabAccordion.enableClick();
    contentAccordion.disableClick();
  } else {
    if (document.querySelectorAll('.specs-home-main-content__item--active').length === 0) {
      // If no accordions are open in mobile and width is expanded to desktop, this opens the first tab content
      tabContent.showTabContent(0);
    }
    mobileAccordion.disableClick();
    tabAccordion.disableClick();
    contentAccordion.enableClick();
  }
});
